import React from 'react'
import { compose } from 'redux'
import { Field, propTypes as formPropTypes } from 'redux-form'
import { lpForm } from 'lp-form'
import { ButtonArea, SubmitButton, Input } from 'lp-components'

const propTypes = {
  ...formPropTypes,
}

const defaultProps = {}

function AddPendingPartnerForm({ handleSubmit, submitting }) {
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="organizationName"
        label="Organization Name"
        component={Input}
        autoComplete="organization"
      />
      <Field
        name="organizationContactFirstName"
        label="Contact First Name"
        component={Input}
        autoComplete="given-name"
      />
      <Field
        name="organizationContactLastName"
        label="Contact Last Name"
        component={Input}
        autoComplete="family-name"
      />
      <Field
        name="organizationContactEmail"
        label="Contact Email"
        component={Input}
        type="email"
        autoComplete="email"
      />
      <Field
        name="organizationContactPhone"
        label="Contact Phone - Optional"
        component={Input}
        type="tel"
        autoComplete="tel"
      />
      <ButtonArea>
        <SubmitButton {...{ submitting, style: 'secondary' }}>
          Create Pending Partnership
        </SubmitButton>
      </ButtonArea>
    </form>
  )
}

AddPendingPartnerForm.propTypes = propTypes
AddPendingPartnerForm.defaultProps = defaultProps

export default compose(
  lpForm({
    name: 'school-add-pending-partner',
    constraints: {
      organizationName: { presence: true },
      organizationContactPhone: {
        format: {
          pattern: /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/,
          message: 'must be a valid phone number - (XXX) XXX-XXXX',
        },
      },
      organizationContactFirstName: { presence: true },
      organizationContactLastName: { presence: true },
      organizationContactEmail: {
        presence: true,
        email: true,
      },
    },
  })
)(AddPendingPartnerForm)
